// Hand-verified IMDb tt-id per entry (title + year + type + cast cross-checked) —
// deliberately NOT derived from the TMDB API: this works for everyone, with no key
// required. Season-split series (dd_s1/2/3, jj_s1/2/3, lc_s1/2, if_s1/2, pun_s1/2,
// loki1/2, whatif1/2/3, xmen97-1/2, yfns1/2) share the same tt-id — IMDb doesn't
// give a separate page per season for these shows.
export const IMDB_ID: Record<string, string> = {
  cap1: 'tt0458339',
  capmarvel: 'tt4154664',
  ironman1: 'tt0371746',
  ironman2: 'tt1228705',
  hulk: 'tt0800080',
  thor1: 'tt0800369',
  avengers1: 'tt0848228',
  thor2: 'tt1981115',
  ironman3: 'tt1300854',
  cap2: 'tt1843866',
  gotg1: 'tt2015381',
  gotg2: 'tt3896198',
  avengers2: 'tt2395427',
  dd_s1: 'tt3322312',
  jj_s1: 'tt2357547',
  antman1: 'tt0478970',
  cap3: 'tt3498820',
  dd_s2: 'tt3322312',
  lc_s1: 'tt3322314',
  blackwidow: 'tt3480822',
  blackpanther1: 'tt1825683',
  spiderman1: 'tt2250912',
  drstrange1: 'tt1211837',
  thor3: 'tt3501632',
  if_s1: 'tt3322310',
  defenders: 'tt4230076',
  pun_s1: 'tt5675620',
  avengers3: 'tt4154756',
  jj_s2: 'tt2357547',
  lc_s2: 'tt3322314',
  if_s2: 'tt3322310',
  dd_s3: 'tt3322312',
  antman2: 'tt5095030',
  pun_s2: 'tt5675620',
  jj_s3: 'tt2357547',
  avengers4: 'tt4154796',
  wandavision: 'tt9140560',
  falcon: 'tt9208876',
  loki1: 'tt9140554',
  whatif1: 'tt10168312',
  farfromhome: 'tt6320628',
  hawkeye: 'tt10160804',
  moonknight: 'tt10234724',
  eternals: 'tt9032400',
  shangchi: 'tt9376612',
  msmarvel: 'tt10857164',
  nowayhome: 'tt10872600',
  drstrange2: 'tt9419884',
  thor4: 'tt10648342',
  shehulk: 'tt10857160',
  wakandaforever: 'tt9114286',
  secretinvasion: 'tt13157618',
  loki2: 'tt9140554',
  whatif2: 'tt10168312',
  quantumania: 'tt10954600',
  gotg3: 'tt6791350',
  marvels: 'tt10676048',
  echo: 'tt13966962',
  'xmen97-1': 'tt16026746',
  xmen1: 'tt0120903',
  x2: 'tt0290334',
  xlaststand: 'tt0376994',
  xorigins: 'tt0458525',
  xfirstclass: 'tt1270798',
  thewolverine: 'tt1430132',
  xdofp: 'tt1877832',
  dp1: 'tt1431045',
  xapocalypse: 'tt3385516',
  logan: 'tt3315342',
  dp2: 'tt5463162',
  darkphoenix: 'tt6565702',
  newmutants: 'tt4682266',
  deadpoolwolverine: 'tt6263850',
  agatha: 'tt15571732',
  whatif3: 'tt10168312',
  yfns1: 'tt16027074',
  bravenewworld: 'tt14513804',
  daredevil1: 'tt18923754',
  thunderbolts: 'tt20969586',
  ironheart: 'tt13623126',
  fantasticfour: 'tt10676052',
  eyesofwakanda: 'tt13968252',
  marvelzombies: 'tt16027014',
  wonderman: 'tt21066182',
  daredevil2: 'tt18923754',
  punisher: 'tt36042156',
  'xmen97-2': 'tt16026746',
  brandnewday: 'tt22084616',
  yfns2: 'tt16027074',
  visionquest: 'tt23112594',
  doomsday: 'tt21357150',
  daredevil3: 'tt18923754',
  secretwars: 'tt21361444',
  xmenreboot: 'tt29347085',
};
